import { render } from "./CategoriaProdutoModal.vue?vue&type=template&id=57c4f935&ts=true"
import script from "./CategoriaProdutoModal.vue?vue&type=script&lang=ts"
export * from "./CategoriaProdutoModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__